import { Box, Stack } from "@mui/material";
import { useCallback, useRef } from "react";
import { useSelector } from "react-redux";
import useEventListener from "@entrilia/shared/hooks/useEventListener.ts";
import { useAppDispatch } from "../../../store/hooks/useAppDispatch.ts";
import { selectSelectedStatementLineId } from "../../../store/selectors/fieldsStateSelectors.ts";
import { createFinancialStatementAction } from "../../../store/utils/storeUtils.ts";
import PartContainer from "../../viewer/common/PartContainer.tsx";
import type { EditorProps } from "../../viewer/common/Types.ts";
import BuilderMoreAction from "../common/fields/BuilderMoreAction.tsx";
import FinancialStatementTableComponent from "./FinancialStatementTableComponent.tsx";
import FinancialStatementPreview from "./preview/FinancialStatementPreview.tsx";
import { keepsLineSelection } from "./utils/lineSelection.ts";

const FinancialStatementEditor = ({ ReportTypeSelector }: EditorProps) => {
  const dispatch = useAppDispatch();
  const selectedLineId = useSelector(selectSelectedStatementLineId);
  const editorRef = useRef<HTMLDivElement>(null);

  const handleMouseDown = useCallback(
    (event: Event) => {
      if (!keepsLineSelection(event.target, editorRef.current)) {
        dispatch(createFinancialStatementAction("setSelectedLineId", undefined));
      }
    },
    [dispatch]
  );
  useEventListener(selectedLineId === undefined ? null : document, "mousedown", handleMouseDown);

  return (
    <Stack ref={editorRef} direction="row" sx={{ flex: 1 }}>
      <PartContainer
        sx={{ maxWidth: "24rem", minWidth: "24rem" }}
        caption={<Box sx={{ pl: "1.3rem" }}>Builder</Box>}
        actions={<BuilderMoreAction />}
      >
        <FinancialStatementTableComponent ReportTypeSelector={ReportTypeSelector} />
      </PartContainer>
      <FinancialStatementPreview />
    </Stack>
  );
};

export default FinancialStatementEditor;
